import React from 'react';
import { useTranslation } from 'react-i18next';

import { useActions } from '@mssgme/hooks';
import { ColorField, ImageField } from '@mssgme/ui';
import { FieldTip, ImageUploadCover } from '@mssgme/app/components/UI';
import CardEditForm from '../CardEditForm';

export default function CoverEdit() {
    const { t } = useTranslation('cards');
    const actions = useActions();

    return (
        <CardEditForm title={t('CoverEdit.title')}>
            {({ values: { design }, setFieldValue }) => (
                <>
                    <ImageField
                        accept="image/png,image/x-png,image/jpeg"
                        as={ImageUploadCover}
                        name="design.background.image"
                        label={t('CoverEdit.labels.photo')}
                        restrictRule="background.image:edit"
                        buttonLabel={t(design.background.imageUrl ? 'designEdit.change_bg_image' : 'CoverEdit.upload')}
                        upload={actions.api.card.uploadCover}
                        previewUrl={design.background.imageUrl}
                        onChange={({ filename, url }) => {
                            setFieldValue('design.background.type', 'image');
                            setFieldValue('design.background.image', filename);
                            setFieldValue('design.background.imageUrl', url);
                        }}
                        onApplyClick={() => setFieldValue('design.background.type', 'image')}
                        active={design.background.type === 'image'}
                    />
                    <ColorField
                        label={t('designEdit.bg_color')}
                        name="design.background.color"
                        value={design.background.type === 'color' ? design.background.color : null}
                        onChange={() => setFieldValue('design.background.type', 'color')}
                    />
                    <FieldTip style={{ marginTop: 30 }}>{t('FieldTip.cover')}</FieldTip>
                </>
            )}
        </CardEditForm>
    );
}
